import React from 'react';
import ImageIcon from '@material-ui/icons/Image';
import { makeStyles } from '@material-ui/core/styles';

import useRenderedImage from '../hooks/useRenderedImage';
import { colors } from '../theme';

const SIZE = 36;

const useStyles = makeStyles({
  box: {
    width: SIZE,
    height: SIZE,
    flexShrink: 0,
    marginRight: 12,
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: colors.panelAlt,
    border: `1px solid ${colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // В закрытом поле: меньше и с отрицательными отступами сверху и снизу, чтобы поле
  // не стало выше, чем без картинки.
  compact: {
    width: 28,
    height: 28,
    margin: '-4px 10px -4px 0',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  placeholder: {
    color: colors.textFaint,
    fontSize: '20px',
  },
});

// Миниатюра шапки шаблона для выпадающего списка. Шаблон без картинки (или пока она
// рисуется) показывает заглушку. Картинку строит сервер по примерным значениям полей.
function TemplateThumb({ template, compact = false }) {
  const classes = useStyles();
  const exampleValues = {};
  if (template.hasImage) {
    template.params.forEach((param) => {
      exampleValues[param.key] = param.example || param.placeholder || '';
    });
  }
  const { url } = useRenderedImage(
    template.hasImage
      ? { template: { name: template.templateName, language: template.language }, values: exampleValues }
      : null
  );

  return (
    <span className={compact ? `${classes.box} ${classes.compact}` : classes.box}>
      {url ? (
        <img className={classes.image} src={url} alt="" />
      ) : (
        <ImageIcon className={classes.placeholder} />
      )}
    </span>
  );
}

export default TemplateThumb;
